var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-fullscreen',[_c('password-forgotten-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }